import { quickOrderProductListStyles as quickOrderProductListStyle } from "@insite/content-library/Widgets/QuickOrder/QuickOrderProductList";
import getColor from "@insite/mobius/utilities/getColor";
import { colorStrings } from "@waytek/Utilities/variables";
import { css } from "styled-components";

quickOrderProductListStyle.removeProductGridItem = {
    ...quickOrderProductListStyle.removeProductGridItem,
    css: css`
        ${quickOrderProductListStyle.removeProductGridItem?.css}
        justify-content: flex-end;
    `,
};

quickOrderProductListStyle.removeProductClickable = {
    ...quickOrderProductListStyle.removeProductClickable,
    css: css`
        ${quickOrderProductListStyle.removeProductClickable?.css}
        margin-right: 0;
    `,
};

quickOrderProductListStyle.addToListLink = {
    link: {
        ...quickOrderProductListStyle.addToListLink?.link,
        css: css`
            ${quickOrderProductListStyle.addToListLink?.link?.css}
            margin-top: 10px;
        `,
    },
};

quickOrderProductListStyle.cardContainer = {
    cardDivider: {
        ...quickOrderProductListStyle.cardContainer?.cardDivider,
        css: css`
            ${quickOrderProductListStyle.cardContainer?.cardDivider?.css}
            border-top-color: ${getColor(colorStrings.commonGlobalIndustrialTaupe)};
            &:last-child {
                border-bottom-color: ${getColor(colorStrings.commonGlobalIndustrialTaupe)};
            }
        `,
    },
};

quickOrderProductListStyle.productInfoGridItem = {
    ...quickOrderProductListStyle.productInfoGridItem,
    width: [7, 8, 9, 9, 9],
};

quickOrderProductListStyle.quantityGridItem = {
    ...quickOrderProductListStyle.quantityGridItem,
    width: [12, 8, 5, 5, 5],
};

quickOrderProductListStyle.quantityOrdered = {
    ...quickOrderProductListStyle.quantityOrdered,
    cssOverrides: {
        ...quickOrderProductListStyle.quantityOrdered?.cssOverrides,
        formInputWrapper: css`
            ${quickOrderProductListStyle.quantityOrdered?.cssOverrides?.formInputWrapper}
            width: 100%;
        `,
    },
};

quickOrderProductListStyle.extendedPriceGridItem = {
    ...quickOrderProductListStyle.extendedPriceGridItem,
    width: [12, 4, 3, 3, 3],
};

quickOrderProductListStyle.removeProductGridItem = {
    ...quickOrderProductListStyle.removeProductGridItem,
    width: [3, 2, 1, 1, 1],
};
